<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-campanha") {
            next({ name: "ven-campanha-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-campanha") {
            this.$router.push({ name: "ven-campanha-list" });
        }
    },
};
</script>